import $ from 'jquery'
import '../scss/module_landing.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { 
    getLoggedForLoginWithHandler,
    getPremiumForLoginWithHandler,
    manageLogin, 
    manageLoginWithListener, 
    openSignUpAndGotoUrl,
 } from './module_auth_helper';
import {
    frontendSubscribeLink,
    updateBuyButtonCta,
    alternativeCheckoutLink,
    manageWelcomeGuestPremium,
    premiumSubscribeMsg,
    successNotification,
    postLoginWithRedirectFuncions,
} from './module_common';

import { initNavbar } from './module_header';

import {
    defaultCarouselSetupVisitor,
} from './module_swiper_visitor';

import {configSkillBooksCarousel} from './module_skill-books-carousel';
import { initCardLazyLoad } from './module_lazyload';

import './module_common_actions';
import { doNotRedirectToProfileOnProblemSendingEmailModalClose } from './module_checkout_helper';
import { handleOfferTimer } from './module_landing_offer_common';
import { handleStartFreemiumForLanding, handleUserLoginLandingFreemium } from './module_login_handler_fn';
import { initSentry } from './module_sentry';

const ctaButtonSelector = ".cta-button-attach-clk"

function manageBuyButtonClick(){
    if(typeof icf != 'undefined' && typeof icAttr != 'undefined' && icf){
        // landing from CMS, freemium template
        // icf (IsCustomFreemium) and icAttr defined in html template
        // maybe from previous login 
        if(getLoggedForLoginWithHandler()){
            if (getPremiumForLoginWithHandler()){
                successNotification(premiumSubscribeMsg)
            }else{
                handleStartFreemiumForLanding()
            }
        }else{
            doNotRedirectToProfileOnProblemSendingEmailModalClose()
            manageLoginWithListener(
                handleUserLoginLandingFreemium,
                postLoginWithRedirectFuncions.handleUserLoginForFreemiumLandin.label,
                null,
                null
            )
        }
    }else if (alternativeCheckoutLink){
        window.location = frontendSubscribeLink
    }else{
        openSignUpAndGotoUrl(frontendSubscribeLink)
    }
}

const mostViewedCarouselSetUp = function(){
    const out = "mostviewed-out"
    const container = "mostviewed-swiper-container"
    defaultCarouselSetupVisitor(container, out, 'auto', 4, 4, 6)
}

const attachCtaButtonClick = function (){
    $(ctaButtonSelector).on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachHeaderBuyButtonClick(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

function attachBuyButtonClick(){
    $('.buy-btn-attach-clk').on('click', function(e){
        manageBuyButtonClick()
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initSentry()
    initFirebaseApp()
    manageLogin()
    
    // do it after do_last call
    manageWelcomeGuestPremium()
    
    doLast();
    
    initNavbar()

    handleOfferTimer()

    initCardLazyLoad()

    configSkillBooksCarousel()
    mostViewedCarouselSetUp()

    attachCtaButtonClick()
    attachHeaderBuyButtonClick()
    attachBuyButtonClick()

    // buttonsCta eventuallly defined in twig template
    if (typeof buttonsCta !== 'undefined'){
        updateBuyButtonCta(buttonsCta)
    }
});